interface ChatQuickPromptsProps {
  onSelect: (prompt: string) => void;
}

const quickPrompts = [
  "Vorrei rifare il mio sito",
  "Quanto costa un progetto?",
  "Ho bisogno di un'area riservata"
];

const ChatQuickPrompts = ({ onSelect }: ChatQuickPromptsProps) => {
  return (
    <div className="chat-quick-prompts">
      {quickPrompts.map((prompt, index) => (
        <button
          key={index}
          className="chat-quick-prompts__button"
          onClick={() => onSelect(prompt)}
        >
          {prompt}
        </button>
      ))}
    </div>
  );
};

export default ChatQuickPrompts;
